import { ScoopTooltip } from '../../ui'
import styles from './NavBarItem.module.scss'

const NavbarItem = ({ icon, label, selected, onClick, disabled, disabledTooltip }) => {
    const handleClick = () => {
        if (!disabled) {
            onClick()
        }
    }

    const tooltipTitle = disabled && disabledTooltip ? disabledTooltip : label

    return (
        <ScoopTooltip title={tooltipTitle}>
            <div
                name={label.toLowerCase() + '-nav-button'}
                aria-label={label}
                aria-disabled={disabled}
                onClick={handleClick}
                className={`${styles.navbarItem} ${selected ? styles.selected : ''} ${disabled ? styles.disabled : ''}`}
            >
                {icon}
            </div>
        </ScoopTooltip>
    )
}

export default NavbarItem
